"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _OnClickOutside = _interopRequireDefault(require("../OnClickOutside"));
var _SearcherDropdownLabel = _interopRequireWildcard(require("./SearcherDropdownLabel"));
var _excluded = ["children", "LabelComponent", "labelContent", "stickTo", "keepDropdownMounted", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SearcherDropdown = /*#__PURE__*/function (_React$PureComponent) {
  function SearcherDropdown(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, SearcherDropdown);
    _this = _callSuper(this, SearcherDropdown, [props]);
    var open = props.open;
    _this.state = {
      focused: open,
      isOpen: open,
      isOpenProp: open,
      handleClick: false
    };
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(SearcherDropdown, _React$PureComponent);
  return (0, _createClass2["default"])(SearcherDropdown, [{
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var key = e.key;
      if (key === 'Tab') {
        this.handleBlur(e);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      var _this2 = this;
      e.stopPropagation();
      e.preventDefault();
      var onFocus = this.props.onFocus;
      var freezed = this.state.freezed;
      if (freezed) {
        return;
      }
      this.setState({
        isOpen: true,
        focused: true
      }, function () {
        onFocus(e);
        setTimeout(function () {
          return _this2.setState({
            handleClick: true,
            freezed: false
          });
        }, 100);
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var onBlur = this.props.onBlur;
      this.setState({
        isOpen: false,
        focused: false,
        handleClick: false
      }, function () {
        return onBlur(e);
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this3 = this;
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        focused = _this$state.focused,
        handleClick = _this$state.handleClick;
      if (handleClick && focused) {
        this.setState({
          isOpen: !isOpen,
          freezed: true
        }, function () {
          setTimeout(function () {
            return _this3.setState({
              freezed: false
            });
          }, 100);
        });
      }
    }
  }, {
    key: "dropdownStyle",
    get: function get() {
      var isOpen = this.state.isOpen;
      return {
        display: isOpen ? 'block' : 'none'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        isOpen = _this$state2.isOpen,
        focused = _this$state2.focused;
      var _this$props = this.props,
        children = _this$props.children,
        LabelComponent = _this$props.LabelComponent,
        labelContent = _this$props.labelContent,
        stickTo = _this$props.stickTo,
        keepDropdownMounted = _this$props.keepDropdownMounted,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], (0, _extends2["default"])({
        className: className
      }, props, {
        onClickOutside: this.handleBlur,
        onKeyDown: this.handleKeyDown
      }), /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
        tabIndex: 0,
        onFocus: this.handleFocus
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onMouseDown: this.handleClick
      }, /*#__PURE__*/_react["default"].createElement(LabelComponent, {
        isOpen: isOpen,
        focused: focused
      }, labelContent)), keepDropdownMounted ? /*#__PURE__*/_react["default"].createElement(StyledDropdown, {
        style: this.dropdownStyle,
        stickTo: stickTo
      }, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isOpen && /*#__PURE__*/_react["default"].createElement(StyledDropdown, {
        stickTo: stickTo
      }, children))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref, _ref2) {
      var isOpen = _ref.open,
        forceClose = _ref.forceClose;
      var isOpenProp = _ref2.isOpenProp;
      if (forceClose) {
        return {
          isOpen: false
        };
      }
      if (isOpen !== isOpenProp) {
        return {
          focused: isOpen,
          isOpenProp: isOpen,
          isOpen: isOpen
        };
      }
      return null;
    }
  }]);
}(_react["default"].PureComponent);
SearcherDropdown.propTypes = {
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  open: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  LabelComponent: _propTypes["default"].func,
  labelContent: _propTypes["default"].node,
  forceClose: _propTypes["default"].bool,
  stickTo: _propTypes["default"].string,
  keepDropdownMounted: _propTypes["default"].bool
};
SearcherDropdown.defaultProps = {
  onBlur: Function.prototype,
  onFocus: Function.prototype,
  open: false,
  forceClose: false,
  stickTo: 'left',
  keepDropdownMounted: false,
  LabelComponent: _SearcherDropdownLabel["default"],
  labelContent: 'Открыть'
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDropdown__StyledWrapper",
  componentId: "sc-nycrih-0"
})(["position:relative;outline:0;min-width:140px;color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackBase;
});
var StyledDropdown = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDropdown__StyledDropdown",
  componentId: "sc-nycrih-1"
})(["overflow:hidden;", ";min-width:232px;z-index:2;margin-top:5px;border-radius:", ";position:absolute;background-color:", ";box-shadow:0 10px 15px 0 rgba(216,214,204,0.9),0 1px 2px 0 rgba(210,208,197,0.9);"], function (_ref4) {
  var stickTo = _ref4.stickTo;
  return "".concat(stickTo, ": 0;");
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.shape.borderRadiusBig;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.white;
});
SearcherDropdown.Input = _SearcherDropdownLabel.StyledLabelContainer;
SearcherDropdown.Dropdown = StyledDropdown;
var _default = exports["default"] = SearcherDropdown;